import { Link } from "react-router-dom";
import AfricaNavbar from "@/components/AfricaNavbar";
import AfricaFooter from "@/components/AfricaFooter";
import { ChevronRight, MapPin } from "lucide-react";

const COUNTRIES = [
  { iso: "ZW", name: "Zimbabwe",     status: "live",    services: ["Vehicles","Property","Sourcing","Escrow","Digital Passports","Certificate verification"], href: "/zw" },
  { iso: "ZA", name: "South Africa", status: "partner",  services: ["Partner onboarding","Enterprise enquiries open"] },
  { iso: "BW", name: "Botswana",     status: "partner",  services: ["Partner onboarding","Enterprise enquiries open"] },
  { iso: "ZM", name: "Zambia",       status: "partner",  services: ["Partner onboarding","Enterprise enquiries open"] },
  { iso: "MZ", name: "Mozambique",   status: "partner",  services: ["Partner onboarding","Enterprise enquiries open"] },
  { iso: "NA", name: "Namibia",      status: "partner",  services: ["Partner onboarding","Enterprise enquiries open"] },
  { iso: "KE", name: "Kenya",        status: "partner",  services: ["Partner onboarding","Enterprise enquiries open"] },
  { iso: "TZ", name: "Tanzania",     status: "coming",   services: ["Coming soon"] },
  { iso: "UG", name: "Uganda",       status: "coming",   services: ["Coming soon"] },
  { iso: "RW", name: "Rwanda",       status: "coming",   services: ["Coming soon"] },
  { iso: "NG", name: "Nigeria",      status: "coming",   services: ["Coming soon"] },
  { iso: "GH", name: "Ghana",        status: "coming",   services: ["Coming soon"] },
  { iso: "CD", name: "DRC",          status: "coming",   services: ["Coming soon"] },
  { iso: "EG", name: "Egypt",        status: "coming",   services: ["Coming soon"] },
  { iso: "MA", name: "Morocco",      status: "coming",   services: ["Coming soon"] },
];

const STATUS_STYLE = {
  live:    { chip: "bg-emerald-500/15 text-emerald-300", label: "Live" },
  partner: { chip: "bg-[#B08C4A]/15 text-[#D4B278]",     label: "Partner onboarding" },
  coming:  { chip: "bg-white/10 text-white/60",          label: "Coming soon" },
};

export default function AfricaCountries() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <AfricaNavbar />
      <section className="max-w-[1500px] mx-auto px-6 py-16 lg:py-24">
        <div className="max-w-[820px]">
          <div className="kicker text-white/60">Continental deployment</div>
          <h1 className="display text-4xl lg:text-6xl mt-3 leading-[1.02]">Select your country.</h1>
          <p className="mt-5 text-white/70 text-[15px] leading-[1.75] max-w-[700px]">
            THOM Verify™ operates as one shared trust infrastructure. Each African country plugs
            in with its own registrars, police databases, currencies, payment providers,
            inspectors and regulators. Zimbabwe is our first live deployment.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="africa-countries-grid">
          {COUNTRIES.map((c) => {
            const s = STATUS_STYLE[c.status];
            return (
              <div key={c.iso} className="border border-white/10 bg-white/[0.02] hover:bg-white/[0.04] transition-colors" data-testid={`africa-country-card-${c.iso}`}>
                <div className="p-6">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <MapPin className="h-4 w-4 text-[#B08C4A]" />
                      <span className="mono text-[10px] uppercase tracking-[0.22em] text-white/60">{c.iso}</span>
                    </div>
                    <span className={`mono text-[9.5px] uppercase tracking-widest px-1.5 py-0.5 rounded-sm ${s.chip}`}>{s.label}</span>
                  </div>
                  <div className="text-2xl font-semibold mt-4 tracking-tight">THOM Verify {c.name}</div>
                  <ul className="mt-4 space-y-1.5 text-[12.5px] text-white/70">
                    {c.services.map((sv) => <li key={sv}>· {sv}</li>)}
                  </ul>
                </div>
                <div className="p-4 border-t border-white/10">
                  {c.status === "live" && c.href ? (
                    <Link to={c.href} className="text-[13px] text-white hover:text-[#B08C4A] inline-flex items-center gap-1" data-testid={`africa-country-enter-${c.iso}`}>
                      Enter THOM Verify {c.name} <ChevronRight className="h-3.5 w-3.5" />
                    </Link>
                  ) : (
                    <Link to={`/africa/countries/${c.iso}/request`} className="text-[13px] text-white/80 hover:text-white inline-flex items-center gap-1" data-testid={`africa-country-request-${c.iso}`}>
                      Request Independent Verification <ChevronRight className="h-3.5 w-3.5" />
                    </Link>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </section>
      <AfricaFooter />
    </div>
  );
}
